//
//
//
//

    import Tabbar from 'vue-django/src/components/mobile/Tabbar.vue'
    export default{
        data () {
            return {
                tabs: [
                    {name: '课程', iconClass: 'menu-cource', link: '/course/course'},
                    {name: '龙虎榜', iconClass: 'menu-ranking', link: '/points/category/ranks'},
                    {name: '我', iconClass: 'menu-user', link: '/about/me'}
                ]
            }
        },
        components: {Tabbar},
        methods: {},
        computed: {}
    }



// WEBPACK FOOTER //
// ./src/components/layout/Tabbar.vue